import { render, staticRenderFns } from "./SplitTheData.vue?vue&type=template&id=9121adb6&scoped=true"
import script from "./SplitTheData.vue?vue&type=script&lang=js"
export * from "./SplitTheData.vue?vue&type=script&lang=js"
import style0 from "./SplitTheData.vue?vue&type=style&index=0&id=9121adb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9121adb6",
  null
  
)

export default component.exports